export default "__VITE_ASSET__nRmI1gGD__"